import {ElementDto} from "../../../../../common/apis/element/ElementDto";

export class ElementPermissionResolver {

    public checkCanDeleteElement(element: ElementDto): boolean {
        return element.acl?.canDelete;
    }

}